import { settings } from "../../../../settings/settings-util";
import { hasNoReason, hasNoComment } from '../util/util';
import h from "virtual-dom/h";


export default class SurveyFooterBuilder
{
    //#region Public Interface

    constructor(settings, linkBuilder)
    {
        this._settings = settings;
        this._linkBuilder = linkBuilder;
    }

    initialize(store)
    {
        this._store = store;
    }

    buildFooter(footerConfig)
    {
        const buttonWrapClassName = this._settings.classNames.surveyFooterButtonWrap || settings.classNames.surveyFooterButtonWrap;
        const cancelClassName = this._settings.classNames.surveyCancelLink || settings.classNames.surveyCancelLink;
        const submitClassName = this._settings.classNames.surveySubmitLink || settings.classNames.surveySubmitLink;

        const submit = this._linkBuilder.buildLink(footerConfig.SubmitLink, submitClassName);
        const cancel = this._linkBuilder.buildLink(footerConfig.CancelLink, cancelClassName);

        if ((footerConfig.SubmitLink.disableUntilCommentAdded && hasNoComment(this._settings, this._store)) ||
            (footerConfig.SubmitLink.disableUntilReasonGiven  && hasNoReason(this._settings, this._store)))
        {
            submit.properties.onclick = null;
            submit.properties.className = this._settings.classNames.surveySubmitLinkDisabled;
            submit.properties.tabIndex = -1;
        }

        return h("div", { className: buttonWrapClassName }, [submit, cancel]);
    }

    //#endregion
}


// WEBPACK FOOTER //
// ./node_modules/@alme/ui-web/modules/simple-feedback-overlay/src/builders/surveyFooterBuilder.js